import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { PlusIcon } from '../icons';
import { generateUUID } from '../utils/useWebSocket';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleNewChat = () => {
    const newId = generateUUID();
    navigate(`/app/chat/${newId}`);
  };

  return (
    <header className="bg-gray-50 border-b border-gray-200">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-end items-center h-[74px]">
          {/* Right side */}
          <nav className="flex items-center space-x-3">
            {/* New chat */}
            <button
              onClick={handleNewChat}
              className="h-8 w-8 rounded-md bg-blue-500 text-white hover:bg-blue-600 flex items-center justify-center transition-colors"
              title="Новый чат"
            >
              <PlusIcon className="h-4 w-4" />
            </button>
            
            {/* User menu */}
            <div className="flex items-center space-x-3">
              <div className="h-8 w-8 rounded-full bg-blue-500 text-white flex items-center justify-center text-xs font-semibold">
                {String(user?.full_name || user?.username || 'CH')
                  .split(' ')
                  .map(part => part[0])
                  .join('')
                  .slice(0, 2)
                  .toUpperCase()}
              </div>
              <button
                onClick={logout}
                className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
              >
                Выйти
              </button>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
